import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { I18nextProvider } from 'react-i18next';
import { RootStoreProvider } from './RootStore';
import Router from './containers/Router';
import i18n from './i18n'; // Your i18n instance
import styles from './App.module.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      structuralSharing: false,
    },
  },
});

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RootStoreProvider>
        <I18nextProvider i18n={i18n}>
          <main className={styles.main}>
            <Router />
          </main>
        </I18nextProvider>
      </RootStoreProvider>
    </QueryClientProvider>
  );
};

export default App;
